module.exports = __webpack_public_path__ + "img/PR2-F.de9b6dcb.png";